<template>
	<app style="background: #fff;">
		<div class="notice">
			<h1 class="title">{{detail.title}}</h1>
			<div v-html="detail.content" class="content"></div>
		</div>
	</app>
</template>

<script>
	export default {
		props: {
			id: String
		},
		
		data() {
			return {
				detail: {}
			}
		},
		
		mounted() {
			this.request({
				url: '/announcement/detail',
				data: {
					id: this.id
				},
				success: data => {
					this.detail = data;
				}
			});
		}
	}
</script>

<style lang="stylus" scoped>
	.notice {
		.title {
			padding: .5rem .3rem .1rem;
			line-height: .6rem;
			font-size: .4rem;
			text-align: center;
			color: #000;
			
			elder({
				line-height: .7rem,
				font-size: .5rem
			})
		}
		
		.content {
			padding: .3rem;
			line-height: .44rem;
			font-size: .28rem;
			
			elder({
				line-height: .56rem,
				font-size: .38rem
			})
		}
	}
</style>
